(() => {
  const CARD_SELECTOR = ".product-item, .cust-tab-product-grid__card";
  const CONTAINER_SELECTOR = ".cust-tab-product-grid__grid, .scroll-slider__slider, .featured-collection-slider-grid";
  let rafId = 0;
  let resizeObserver;
  let mutationObserver;

  const isVisible = (el) => {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== "none" && style.visibility !== "hidden";
  };

  const getCards = (container) =>
    Array.from(container.querySelectorAll(CARD_SELECTOR)).filter((el) => isVisible(el));

  const resetHeights = (cards) => {
    cards.forEach((card) => {
      card.style.height = "";
      card.style.minHeight = "";
    });
  };

  const normalizeCardLayout = (cards) => {
    cards.forEach((card) => {
      const inner = card.querySelector(".product-item__inner");
      const meta = card.querySelector(".product-item__meta");
      const text = card.querySelector(".product-item__text");
      const primary = card.querySelector(".product-item__text_group_primary");
      const bottom = card.querySelector(".custom-bottom-wrap");

      if (inner) {
        inner.style.display = "flex";
        inner.style.flexDirection = "column";
        inner.style.height = "100%";
      }
      if (meta) {
        meta.style.display = "flex";
        meta.style.flexDirection = "column";
        meta.style.flex = "1 1 auto";
        meta.style.height = "100%";
      }
      if (text) {
        text.style.display = "flex";
        text.style.flexDirection = "column";
        text.style.flex = "1 1 auto";
        text.style.height = "100%";
      }
      if (primary) {
        primary.style.display = "flex";
        primary.style.flexDirection = "column";
        primary.style.flex = "1 1 auto";
        primary.style.minHeight = "0";
      }
      if (bottom) {
        bottom.style.marginTop = "auto";
      }
    });
  };

  const equalizeAllCards = (cards) => {
    if (cards.length < 2) return;
    let maxHeight = 0;
    cards.forEach((card) => {
      maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
    });
    cards.forEach((card) => {
      card.style.height = `${Math.ceil(maxHeight)}px`;
    });
  };

  const equalizeCardsByRow = (cards) => {
    if (cards.length < 2) return;
    const rowMap = new Map();

    cards.forEach((card) => {
      const top = Math.round(card.getBoundingClientRect().top);
      if (!rowMap.has(top)) rowMap.set(top, []);
      rowMap.get(top).push(card);
    });

    rowMap.forEach((rowCards) => {
      if (rowCards.length < 2) return;
      let maxHeight = 0;
      rowCards.forEach((card) => {
        maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
      });
      rowCards.forEach((card) => {
        card.style.height = `${Math.ceil(maxHeight)}px`;
      });
    });
  };

  const shouldTreatAsSlider = (container) => {
    if (container.classList.contains("scroll-slider__slider")) return true;
    const style = window.getComputedStyle(container);
    return style.display.includes("flex") && style.overflowX !== "visible";
  };

  const equalizeContainer = (container) => {
    if (!container || !isVisible(container)) return;
    const cards = getCards(container);
    normalizeCardLayout(cards);
    resetHeights(cards);
    if (shouldTreatAsSlider(container)) {
      equalizeAllCards(cards);
    } else {
      equalizeCardsByRow(cards);
    }
  };

  const runEqualize = () => {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);
    containers.forEach(equalizeContainer);
  };

  const schedule = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      runEqualize();
      rafId = 0;
    });
  };

  const observeContainers = () => {
    if (!resizeObserver) return;
    document.querySelectorAll(CONTAINER_SELECTOR).forEach((el) => resizeObserver.observe(el));
  };

  const init = () => {
    if (resizeObserver || mutationObserver) return;
    resizeObserver = new ResizeObserver(() => schedule());
    observeContainers();

    mutationObserver = new MutationObserver(() => {
      observeContainers();
      schedule();
      // Async product recommendations often update in batches
      setTimeout(schedule, 80);
      setTimeout(schedule, 220);
      setTimeout(schedule, 480);
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    schedule();
    setTimeout(schedule, 120);
    setTimeout(schedule, 360);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("load", schedule);
  document.addEventListener(
    "load",
    (event) => {
      if (event.target && event.target.tagName === "IMG") {
        schedule();
      }
    },
    true
  );

  document.addEventListener("shopify:section:load", schedule);
  document.addEventListener("shopify:block:select", schedule);
  document.addEventListener("click", (event) => {
    if (event.target && event.target.closest(".cust-tab-product-grid__tab")) {
      setTimeout(schedule, 40);
      setTimeout(schedule, 180);
    }
  });

  document.addEventListener("scroll-slider-complementary-products:initialized", schedule);
  document.addEventListener("scroll-slider-complementary-products:slide-changed", schedule);
})();
